export const formatClubWebsiteForDisplay = (
  website: string,
): string => {
  const regEx = /^(?:https?:\/\/)?(?:[^@/\n]+@)?(?:www\.)?([^:/\n]+)/
  const matches = regEx.exec(website);
  if (matches) return matches[1]
  else return ''
}
